module.exports = __webpack_public_path__ + "img/brand/cha-logo-negative.svg";